interface ResultsSummaryProps {
  totalCount: number;
  filteredCount: number;
  totalAmount: string;
}

export function ResultsSummary({ totalCount, filteredCount, totalAmount }: ResultsSummaryProps) {
  return (
    <div className="flex items-center justify-between">
      <div className="text-[14px] text-[#718096]">
        Showing <span className="font-semibold text-[#1B365D]">{filteredCount}</span> of {totalCount} expenses
      </div>
      <div className="text-[14px] text-[#718096]">
        Total: <span className="font-semibold text-[#1B365D] font-mono">{totalAmount}</span>
      </div>
    </div>
  );
}
